import React from "react";

const TextTeamDeleteMessage = () => {
  return (
    <div>If you want to delete the team, first, remove all its quizzes and members.</div>
  )
}

export default TextTeamDeleteMessage